import React, { useEffect } from 'react';
import { Wordmark } from '../../ui/index.js';
import '../legal/privacy.css';

// Unknown address (eksik listesi P2, 5 Kasım 2026): a mistyped short link says so in the visitor's language and offers the
// two ways in, instead of silently opening the onboarding.
export function NotFoundPage() {
  const en = new URLSearchParams(location.search).get('lang') === 'en';
  useEffect(() => { document.documentElement.lang = en ? 'en' : 'tr'; document.title = `BiSponsor · ${en ? 'Page not found' : 'Sayfa bulunamadı'}`; }, [en]);
  return <main className="privacy-page" aria-labelledby="not-found-title">
    <a href="/" className="privacy-home" aria-label="BiSponsor"><Wordmark /></a>
    <h1 id="not-found-title">{en ? 'Page not found' : 'Sayfa bulunamadı'}</h1>
    <p>{en ? 'The address may be mistyped or the page may have moved.' : 'Adres yanlış yazılmış ya da sayfa taşınmış olabilir.'}</p>
    <p className="privacy-meta"><a href={en ? '/onboarding?lang=en' : '/onboarding'}>{en ? 'Get started' : 'Başlayalım'}</a> · <a href={en ? '/panel?lang=en' : '/panel'}>{en ? 'Sign in' : 'Giriş yap'}</a></p>
  </main>;
}
